






























import mixins from 'vue-typed-mixins';
import { DataTableHeader } from 'vuetify';
import OversightUtils, { OversightOrganization } from '@/utils/OversightUtils';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<OversightOrganization>[] {
      return [
        { text: this.$i18n.tc('model.common.name', 2), value: 'name' },
        {
          text: this.$i18n.tc('app.label.type', 2),
          value: 'oversighttype.name',
        },
        { text: this.$i18n.tc('model.common.parent', 2), value: 'parent.name' },
      ];
    },
  },
  data(): {
    instances?: OversightOrganization[];
  } {
    return {
      instances: undefined,
    };
  },
  async mounted() {
    try {
      this.instances = await OversightUtils.api.instance.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      await this.$router.push({ name: 'oversight-create' });
    },
    async edit(oversight: OversightOrganization) {
      await this.$router.push({
        name: 'oversight-edit',
        params: { id: `${oversight.id}` },
      });
    },
    async remove(oversight: OversightOrganization) {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [
            this.$translate(oversight.name),
          ])
          .toString(),
        async () => {
          if (oversight.id && this.instances) {
            this.$alert.hide('remove');
            await OversightUtils.api.instance.remove(oversight.id);
            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [oversight.name],
              }),
            });
            const index = this.instances.findIndex(
              (val) => val.id === oversight.id
            );
            if (index >= 0) {
              this.instances.splice(index, 1);
            }
          }
        }
      );
    },
  },
});
